<template>
  <div class="loading-cmp-wrapper" v-show="s_loading">
    <!-- 遮罩层 -->
    <van-overlay :show="s_loading" class="overlay-wrapper">
      <van-loading type="spinner">加载中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters('global', ['s_loading']),
    },
    data() {
      return {}
    }
  }
</script>

<style lang="scss" scoped>
  .loading-cmp-wrapper {
    width: 100%;
    height: 100px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    .overlay-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      .van-loading__spinner{
        width: 60px;
        height: 60px;
      }
      .van-loading__text {
        font-size: 28px;
      }
    }
  }
</style>